import { gql, useSubscription } from '@apollo/client';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { FeatureFlag } from '@swf/core/enums';
import useFeature from '@swf/core/hooks/useFeature';
import type { Dispatch } from '@swf/core/store';
import { select } from '@swf/core/store';

import {
  TXTWCL_Responsible_Gaming_Reminder,
  TXTWCL_Your_winnings_can_be_withdrawn_ELL
} from './useLargePrizeSubscription.messages.json';

export const LargePrizeNotificationSubscription = gql`
  subscription GetLargePrizeNotifications {
    getLargePrizeNotifications {
      id
    }
  }
`;

const useLargePrizeSubscription = () => {
  const { modal } = useDispatch<Dispatch>();
  const { idpToken } = useSelector(select.session.get);
  const { formatMessage } = useIntl();
  const enableBigWinningsSubscription = useFeature(FeatureFlag.EnableBigWinningsGQLSubscription);

  useSubscription(LargePrizeNotificationSubscription, {
    skip: !idpToken || !enableBigWinningsSubscription,
    onData: () => {
      modal.unique({
        path: '/notifications/simple-notification',
        locationState: {
          title: formatMessage(TXTWCL_Responsible_Gaming_Reminder),
          msg: formatMessage(TXTWCL_Your_winnings_can_be_withdrawn_ELL)
        }
      });
    }
  });
};

export default useLargePrizeSubscription;
